import { Box, styled } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';
import { colors } from 'app/theme/config';
import { ThemeModeEnum } from 'shared/enums/ThemeModeEnum';

export const bannerButtonSx: SxProps<Theme> = (theme) => ({
  ...theme.typography.body1,
  fontWeight: 700,
});

export const RootBox = styled(Box)(({ theme }) => ({
  backgroundColor:
    theme.themeName === ThemeModeEnum.HIGH_CONTRAST_ACCESSIBLE ? colors.black : colors.gallery,
  padding: '30px 0',
  borderBottom:
    theme.themeName === ThemeModeEnum.HIGH_CONTRAST_ACCESSIBLE
      ? `3px solid ${colors.white}`
      : 'none',
}));
